/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import {WealthyEnv} from "helpers";

const investmentExpertsStories = [
  {
    id: 1,
    name: "Aditya Agarwal",
    avatarImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/aditya-investment-experts2.png`,
    description: "An IIT Bombay graduate, Aditya worked with MNC consulting firms and was advising friends & family on their investments before starting Wealthy.",
    linkedIn: "https://www.linkedin.com/in/adagarwal/"
  },
  {
    id: 2,
    name: "Prashant Gupta",
    avatarImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/wealthy-landing-page-experts-prashant.png`,
    description: "An engineer from IIT Madras and a MBA graduate from IIM-Ahmedabad, Prashant was advising family offices at Morgan Stanley before starting Wealthy.",
    linkedIn: "https://www.linkedin.com/in/prashant-gupta-1b884b6/"
  },
  {
    id: 3,
    name: "Jaya Singh",
    avatarImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/wealthy-landing-page-experts-jaya.png`,
    description: "Jaya was instrumental in setting up the Wealth business for Citibank in India. She brings over two decades of experience in portfolio construction and product diligence.",
    linkedIn: "https://www.linkedin.com/in/jaya-singh-63a48a193/"
  },
  {
    id: 4,
    name: "Niharika Tripathi",
    avatarImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/wealthy-landing-page-experts-niharika.png`,
    description: "Niharika brings over 18 years of experience in the Wealth Management industry across Private Banking, Products and strategy. Her last stint was with Citibank, India.",
    linkedIn: "https://www.linkedin.com/in/niharika-tripathi-1a593a4/"
  },
  {
    id: 6,
    name: "Suman Das",
    avatarImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/wealthy-landing-page-experts-suman.png`,
    description: "An MBA from IIM-Bangalore, Suman is working to combine the know-how of our investment experts with the prowess of our technology team.",
    linkedIn: "https://www.linkedin.com/in/suman-das-86203465/"
  },
  {
    id: 7,
    name: "Chandan Savvant",
    avatarImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/wealthy-landing-page-experts-savvant.png`,
    description: "Previously with Axis AMC, Savant is a known leader from Asset Management industry. At Wealthy, he coaches Wealth Partners to deliver a world-class Wealth Management experience.",
    linkedIn: "https://www.linkedin.com/in/thinksavant/"
  },
  {
    id: 8,
    name: "Varun Krishna",
    position: "Some Post",
    avatarImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/wealthy-landing-page-experts-varun.png`,
    description: "CFP by education, Varun brings decades of experience in managing Wealth for end-clients. At Wealthy, he helps implement tools & techniques that help a Wealth Partner serve their clients better.",
    linkedIn: "https://www.linkedin.com/in/varunkrishnacfp/"
  }
];

export default investmentExpertsStories;
